import React,{useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom';
import {URL} from '../Helper/helper'
import timings from './timings.js'
import './BookingsComponent.css'

function BookingsComponent() {

  const navigate = useNavigate()

 const[dateSelected,setDateSelected] = useState('')
 const[timeSelected,setTimeSelected] = useState('')
 const[courtSelected,setCourtSelected] = useState('')
 const[count,setCount] = useState(0)
 const[day,setDay] = useState(-1)
 const[price,setPrice] = useState(0)
 const[addBookings,setAddBookings] = useState([])
 const[bookings,setBookings] = useState([])
 const[courtsAvailable,setCourtsAvailable] = useState([])
 const[courtsBooked,setCourtsBooked] = useState([])
 
 const user_info = JSON.parse(localStorage.getItem('user'))
 
 const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
 const courts_List = ['Court-1','Court-2','Court-3','Court-4','Court-5','Court-6']
 
 useEffect(() =>{

    // if(!user_info){
    //     navigate('/')
    // }
    async function invokeBookings(){
        const bookingsData = await fetch(`${URL}`+'/bookings') 
        const bookingResponse = await bookingsData.json()
        console.log('Bookings Response',bookingResponse)
        setBookings(bookingResponse)
    }

    invokeBookings()
    
 },[dateSelected,timeSelected])


 const handleDate = (e) =>{
    console.log('date selected :', e.target.value)

    let booking_date = e.target.value;
    let day_of_week = new Date(e.target.value).getDay();

    console.log('Day of the Week :',day_of_week)

    setDay(day_of_week)
    setDateSelected(booking_date)

 }

 const handleBookingTime = (e) =>{
    
    console.log('Time-Slot', e.target.value)
    let timeSlotSelected = e.target.value.split('-')[0];
    setTimeSelected(e.target.value)
    let courts_Booked = bookings
                        .filter(b => b.booking_time_start === timeSlotSelected && b.booking_date === dateSelected)
                        .map(c => c.booking_item)
    //let total_courts = courts_Available.map(c => c.booking_item)

    setCourtsBooked(courts_Booked)
    console.log('C Booked',courts_Booked)

    let courts_Left = courts_List.filter(val => !courts_Booked.includes(val))
    setCourtsAvailable(courts_Left)
    console.log('Left :',courts_Left)
 }

 const handleCourtSelection = (e) =>{
      setCourtSelected(e.target.value)
 }

 const handleAddBookings = (e) =>{
    
    //const{name,value} = e.target;
    
    let total_price = price + 8;
    let bookingObj = {
      booking_date:dateSelected,
      // booking_date_end:dateSelected,
      booking_time_start:timeSelected.split('-')[0],
      booking_time_end:timeSelected.split('-')[1],
      booking_item:courtSelected,
      userName:'venky123', //user_info.userName,
      booking_status:'Confirm',
      booking_price:total_price
    }
    if(dateSelected.length > 0 && timeSelected.length > 0 && courtSelected.length > 0){
      setPrice(prevState => prevState + 8)
      setAddBookings(prevState => [...prevState,bookingObj])
    }
    
    //setDateSelected('')
    //setTimeSelected('')
    setCourtSelected('')
    //setPrice(0)
 }                   

 const handlePaymentCheckout = (e) =>{

  e.preventDefault();
    
  try{
      if(addBookings && addBookings.length > 0){
        addBookings.forEach(async(booking,index) =>{

            const options = {
              method: "POST",
              headers: {
                "content-type": "application/json"
              },
              body: JSON.stringify(booking)
            }
            const response = await fetch(`${URL}`+'/bookings',options)
            
            if(response.ok){
                setCount(prevState =>prevState + 1)
                setAddBookings([])
                setDateSelected('')
                setTimeSelected('')
                setCourtSelected('')
                setPrice(0)
                alert('Bookings Successful')
            }
            // response.catch(err => console.log(err))
          
        })
        if (count === addBookings.length) {

            alert(count)
        }
     
        
      }
  }
  catch(err){
      console.log(err)
  }     

 }

  return (
    <div className='wrapper'>
      <div className="container">
        <h4 className='text-center m-3 text-secondary p-3'>Bookings</h4>
        <div className="row justify-content-evenly"> 
            <div className="col-4">
              <input type="date" name="date-picker" id="date" className='form-control' value={dateSelected} onChange={handleDate} />
            </div>
            <div className="col-4">
              <select name="booking-time" id="booking-time" className='form-select' value={timeSelected} onChange={handleBookingTime}>
                <option value='-1' className='text-center'>-- Select Time --</option>
                {
                    day === 0 ? 
                      timings.sun.map((time,idx) =><option key={idx} className='text-center' value={time}>{time}</option>)
                    :
                    day === 6 ?
                      timings.sat.map((time,idx) =><option key={idx} className='text-center' value={time}>{time}</option>)
                    :
                    timings.weekdays.map((time,idx) =><option key={idx} className='text-center' value={time}>{time}</option>)
                }
              
              </select>
            </div>
            <div className="col-4">
              <select name="courts" id="courts" className='form-select' value={courtSelected} onChange={handleCourtSelection}>
                <option value="-1" className='text-center'>-- Select Courts --</option>
                {
                  courtsAvailable.map(court => <option key={court} value={court} className='text-center'>{court}</option>)
                }
              </select>
            </div>
        </div>
        {/* <h6 className='text-center my-5'>Day-Selected - {''} <b className='text-danger'>{weekday[day]}</b></h6> */}
        <div className='d-flex flex-row justify-content-between py-4 mb-3' >
          <h6 className='text-start'>Total : <strong className='p-2'>${price}.00</strong></h6>
          <button 
            className='btn btn-warning btn-sm book-btn' 
            onClick={handleAddBookings}>
              <i className='fa-sharp fa-solid fa-plus'></i>
          </button>
        </div>
        <div className="booking-info">
          <table className='table table-bordered my-3'>
            <thead>
              <tr>
                <td>S.No</td>
                <td>BookingDate</td>
                <td>Item</td>
                <td>Time</td>
              </tr>
            </thead>
            <tbody>
              {
                addBookings.map((b,i)=><tr key={i}>
                  <td>{i+1}</td>
                  <td>{b.booking_date}</td>
                  <td>{b.booking_item}</td>
                  <td>{b.booking_time_start}</td>
                </tr>)
              }
            </tbody>
          </table>
          <button  
            className="btn btn-warning book-btn btn-checkout" 
            onClick={handlePaymentCheckout}><i><b>checkout</b></i></button>
        </div>
      </div>
    </div>
  )
}

export default BookingsComponent